<script lang="ts" generics="Element extends OsmElementWithTags">
  import { ChevronDown } from "@lucide/svelte";
  import {
    type OsmElement,
    type OsmElementWithTags,
    osmProfile,
  } from "../../lib/osm.ts";
  import * as Item from "../ui/item/index.ts";

  let {
    title,
    elements,
    onSelect,
    collapsed = false,
  }: {
    title: string;
    elements: Element[];
    onSelect: (element: Element) => void;
    collapsed?: boolean;
  } = $props();

  function osmElementKey(element: OsmElement): string {
    return `${element.type}:${element.id}`;
  }

  function osmElementSummary(element: OsmElementWithTags): {
    title: string;
    subtitle: string;
  } {
    const details = osmProfile(element.tags);

    if (details.name) {
      return {
        title: details.name,
        subtitle: details.typeLabel ?? "Map feature",
      };
    }
    return {
      title: details.typeLabel ?? "Unnamed",
      subtitle: "Map feature",
    };
  }
</script>

{#snippet elementList()}
  <Item.Group class="mt-2 gap-1 px-2">
    {#each elements as element (osmElementKey(element))}
      {@const summary = osmElementSummary(element)}
      <Item.Root
        size="sm"
        class="w-full cursor-pointer gap-3 px-2 py-2 text-left hover:bg-accent"
      >
        {#snippet child({ props })}
          <button type="button" {...props} onclick={() => onSelect(element)}>
            <Item.Content class="min-w-0">
              <Item.Title class="truncate font-normal">
                {summary.title}
              </Item.Title>
              <Item.Description class="truncate text-xs">
                {summary.subtitle}
              </Item.Description>
            </Item.Content>
          </button>
        {/snippet}
      </Item.Root>
    {/each}
  </Item.Group>
{/snippet}

{#if elements.length > 0}
  {#if collapsed}
    <details class="group mt-5 border-t border-border pt-4">
      <summary
        class="flex cursor-pointer list-none items-center justify-between gap-3 px-4 text-xs font-semibold uppercase text-muted-foreground [&::-webkit-details-marker]:hidden"
      >
        <span>{title}</span>
        <ChevronDown
          class="size-3.5 transition-transform group-open:rotate-180"
        />
      </summary>

      {@render elementList()}
    </details>
  {:else}
    <section class="mt-5 border-t border-border pt-4">
      <h3 class="px-4 text-xs font-semibold uppercase text-muted-foreground">
        {title}
      </h3>

      {@render elementList()}
    </section>
  {/if}
{/if}
